import React from 'react'
import { Box, Typography, useMediaQuery, Link } from '@mui/material';
import theme from './../../../theme';

const MapComponent = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const googleMapLink = "https://maps.app.goo.gl/sjHWmdCSJzKq4fv2A";
  const googleMapEmbedSrc =
    "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d231.23078992748725!2d96.07804920000004!3d21.984756500000177!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30cb6cd78c08d77f%3A0x5b95f9a9e8829e32!2z4YCZ4YCU4YC54YCQ4oCL4YCc4YCx4YC44YCe4YC24YCG4YCt4YCv4YCE4YC6!5e0!3m2!1sen!2smm!4v1772536838337!5m2!1sen!2smm";

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        padding: isMobile ? "10px" : "20px",
      }}
    >
      <Typography
        variant='p'
        sx={{
          fontFamily: `'Amiko', 'Roboto', 'Instrument Sans', sans-serif`,
          fontWeight: 700,
          fontSize: isMobile ? "14px" : "18px", // Adjust font size for mobile
          textAlign: "center",
        }}
      >
        “Visit our Stores! We can’t wait to welcome you!”
      </Typography>

      <div style={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
        height: isMobile? "auto" : "400px",
        marginTop: "20px",
        borderRadius: "25px"
      }}>
        <iframe
          src={googleMapEmbedSrc}
          width="85%"
          height= {isMobile ? "300px" :"100%"}
          frameBorder="0"
          style={{
            border: 0,
            borderRadius: "15px", 
            overflow: "hidden", 
          }}
          allowFullScreen=""
          aria-hidden="false"
          tabIndex="0"
          title="Google Map"
        />

      </div>
      <Link
        href={googleMapLink}
        target="_blank"
        rel="noopener noreferrer"
        sx={{ marginTop: "12px", color: "#515151", textDecoration: "none" }}
      >
        Open in Google Maps
      </Link>

    </Box>
  )
}

export default MapComponent
